var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"tabs-scroll"},[_c('div',{staticClass:"tabs-scroll__container container"},[_c('div',{staticClass:"tabs-scroll__body"},[_c('am-tabs',{attrs:{"breakpoint":_vm.breakpoint,"value":_vm.value,"tabs":_vm.tabs,"minWidth":true},on:{"change":_vm.onChange}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }